import axios from 'axios';
import { isNil, merge } from 'lodash';
import { getApiRoute } from '../../config';

/**
 * Returns CMS application settings for selected company
 * @param game [mandatory] Game name, all lowercase without special characters and spaces
 * @param company [mandatory] Company UUID
 * @param env [optional] Environment
 * @param setting [optional] Setting key, `config` by default
 * @param channel [optional] Delivery channel - retail, terminal, web, mobile
 * @param platform [optional] Game platform - linux, windows, rpi
 * @param betshop [optional] Betshop UUID
 * @param device [optional] Device UUID
 * @returns {Object} Filtered object according to other params
 */
export default {
  getAppSettings({ game, company, env, setting = 'config', channel, platform, betshop, device }) {

    return axios
      .get(`${getApiRoute('cmsApi', env)}apps/7v_${company}/settings`)
      .then(response => {
        const responseObj = response.data;
        let tempConf = {};
        let conf = {};

        const settingSpecific = {
          game: game && game.toLowerCase(),
          channel: channel && channel.toLowerCase(),
          platform: platform && platform.toLowerCase(),
          betshopUuid: betshop,
          deviceUuid: device
        };

        if (responseObj.appSettings && responseObj.appSettings[setting]
          && Object.keys(responseObj.appSettings[setting]).length > 0) {

          tempConf = responseObj.appSettings[setting];

          // common settings
          if (tempConf.common && Object.keys(tempConf.common).length > 0) {
            conf = tempConf.common;
          }

          // type specific settings, level 1
          Object.keys(settingSpecific).forEach(function(key) {
            const l1 = tempConf[settingSpecific[key]];

            if (!isNil(l1)) {
              merge(conf, l1);

              if (typeof l1 === 'object') {
                Object.keys(l1).forEach(function(subkey) {
                  const l2 = l1[subkey];

                  // check if settingSpecific exists deeper, level 2
                  for (let type in settingSpecific) {
                    if (settingSpecific[type] === subkey) {
                      merge(conf, l2);
                    }
                  }

                });
              }
            }
          });
        }

        // return filtered data
        return conf;
      });
  },

  /**
   * Returns CMS application template settings
   * @param template [mandatory] Template name
   * @param env [optional] Environment
   * @param setting [optional] Setting key, empty by default
   * @returns {Object} Filtered object
   */
  getAppTemplateSettings({ template, setting = '' }) {
    console.log('[V-SDK] getTemplateSettings!');

    return axios
      .get(`${getApiRoute('cmsApi', env)}app-templates/${template}/settings/${setting}`)
      .then(response => {
        const responseObj = response.data;
        let conf;

        conf = setting !== '' && responseObj.appTemplateSetting ?
          responseObj.appTemplateSetting[setting] : responseObj.appTemplateSettings;

        // return filtered data
        return conf;
      });
  },
};
